import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { Box, Label } from "Application";
import { DocumentIcon } from "../../Assets/Icons/DocumentIcon";
import useMediaQuery from "Application/Hooks/useMediaQuery";
import { DocumentListViewModel } from "./DocumentListViewModel";
import { Modal } from "react-responsive-modal";
interface Props {
    id: string;
    title: string;
    fileName: string;
    viewModel: DocumentListViewModel;
}
export const DocumentView: React.FC<Props> = observer((props) => {
    const isMobile = useMediaQuery("(max-width: 767px)");
    return (
        <>
            <Box style={{ cursor: "pointer" }} onClick={() => props.viewModel.getDocumentCommand.execute(props.id)}>
                <Box mt={isMobile ? "12px " : 3} display={"flex"} alignItems={"center"}>
                    <DocumentIcon fill="#B88E00" style={{ flex: "20px 0 0" }} />
                    <Label ml={"3"} mt={"0"} style={{ font: "normal normal normal 12px/15px Lato", letterSpacing: "-0.18px", color: "#4A4A4A", cursor: "pointer" }}>
                        {props.fileName}
                    </Label>
                </Box>
            </Box>
        </>
    );
});
